import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }


const __default__ = { name: 'Home' }

import { onMounted, ref } from 'vue';
import HomeHeader from './components/home-header.vue';
import HomeContent from './components/home-content.vue';
import HomeFooter from './components/home-footer.vue';

// const headerEl = ref<typeof HomeHeader>();
// onMounted(() => {
//   console.log(headerEl.value?.getCount);
// });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HomeHeader),
    _createVNode(HomeContent),
    _createVNode(HomeFooter, { class: "home-footer" })
  ]))
}
}

})